<div *ngIf="!selectedSegment">
  <input
    data-cy="segment-legacy-input"
    class="input-legacy"
    type="text"
    placeholder="{{ 'MAINTENANCES.SEGMENT_PLACEHOLDER' | translate }}"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedSegment()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option
      data-cy="segment-legacy-option"
      [matTooltip]="segment.name"
      [matTooltipShowDelay]="500"
      *ngFor="let segment of segments"
      [value]="segment.id"
    >
      {{ segment.name }}
    </mat-option>
    <mat-option *ngIf="!segments.length">
      {{ 'MAINTENANCES.SEGMENT_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="selectedSegment">
  <input class="input-legacy" type="text" disabled [value]="selectedSegment.name" />

  <button mat-icon-button class="cancel-button" *ngIf="selectedSegment" (click)="deselectSegment()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
